import Data from '../common/data';
export default class AutoRegister {
    constructor(registerPop) {
        this.registerPop = registerPop;
        this.count = 0;
        this.timerId = null;
        this.includeBlur = false;
        return this;
    }

    start() {
        this.offListener();
        this.registerPop.$EventBus.$on(
            'emailLead-register',
            this.startEmailLead.bind(this, true)
        );
        this.registerPop.$EventBus.$on(
            'vInput-blur',
            this.onInputBlur.bind(this)
        );
    }

    onInputBlur(name, value, el) {
        // 必须先点击'next'后才能接收失焦事件
        if (!this.includeBlur) return;
        if (
            !['email', 'phone', 'fullname', 'lastName', 'firstName'].includes(
                name
            )
        ) {
            return;
        }
        if (!this.registerPop.$el.contains(el)) return;
        this.startEmailLead();
    }

    async startEmailLead(fromNextbt) {
        if (fromNextbt) this.includeBlur = true;
        // 是否注册Email Lead 根据cms开关配置。所有注册入口统一
        if (
            Data &&
            Data.site &&
            (Data.site.emailLead || typeof Data.site.emailLead === 'undefined')
        ) {
            if (this.registerPop.user) return; // 已登陆不做处理
            if (this.user) return;
            this.count++;
            if (this.timerId) {
                clearTimeout(this.timerId);
            }

            this.timerId = setTimeout(async () => {
                this.timerId = null;
                // 收集数据
                let data = await this.getherData();
                // 注册弹框实例数据整理
                const registerPop = this.registerPop;
                const registerOptions = this.registerPop.options || {};
                data = Object.assign(
                    registerOptions.registerData || {},
                    registerPop.step1Data || {},
                    data
                );
                if (data.email) {
                    this.registerPop[
                        this.registerPop.showThirdNext
                            ? 'thirdPartyAutoRegister'
                            : 'leadAutoRegister'
                    ](data);
                }
            }, 2000);
        }
    }

    async getherData() {
        // 所有注册表单的form都要加上ref
        let dataArr = await Promise.all(
            ['form', 'form-step1', 'form-step2', 'third-next']
                .map(k =>
                    k === 'third-next'
                        ? this.registerPop.$refs[k] &&
                          this.registerPop.$refs[k].$refs.form
                        : this.registerPop.$refs[k]
                )
                .filter(Boolean)
                .filter(f => f.validate)
                .map(formInstance => async () => {
                    // 调用表单实例校验数据方法获取表单数据
                    let result = await formInstance.validate(true);
                    let data = { ...formInstance.formData };
                    result.forEach(r => {
                        if (data[r.name] && (!r.valid || !r.value)) {
                            delete data[r.name];
                        }
                    });
                    return data;
                })
                .map(f => f())
        );
        return dataArr.reduce((finalData, d) => {
            return Object.assign(finalData, d);
        }, {});
    }

    offListener() {
        this.registerPop.$EventBus.$off(
            'emailLead-register',
            this.startEmailLead
        );
        this.registerPop.$EventBus.$off('vInput-blur', this.onInputBlur);
    }
}
const instances = new Map();

// 注册弹框关闭时，取消监听
AutoRegister.prototype.destroy = function () {
    this.offListener();
    instances.delete(this.registerPop);
};

AutoRegister.getInstance = function (vm) {
    let instance = instances.get(vm);
    if (instance) return instance;
    instance = new AutoRegister(vm);
    instances.set(vm, instance);
    return instance;
};
